import React, { useState } from 'react';
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';
import SendIcon from '@mui/icons-material/Send';
import { StyledPaper, StyledTextField, StyledIconButton } from './styles';

export default function InputMessage({
  inputRef,
  value,
  onChange,
  onSubmit,
  onDelete,
  toggleModal,
  status,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleChange = (event) => {
    onChange(event);
  };

  const handleDeleteClick = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    setIsDeleteDialogOpen(false);
    onDelete();
  };

  const handleCancelDelete = () => {
    setIsDeleteDialogOpen(false);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (status !== 'ready') return;
          if (!value) return;
          onSubmit();
        }}
      >
        <StyledPaper>
          <Tooltip title="Clear chat" arrow>
            <IconButton
              aria-label="delete"
              data-test-id="search_sections_bet_clear_chat"
              onClick={handleDeleteClick}
              size="large"
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Templates" arrow>
            <IconButton
              onClick={toggleModal}
              variant="contained"
              data-test-id="search_sections_bet_question_templates"
              size="large"
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
          <StyledTextField
            inputRef={inputRef}
            value={value}
            onChange={handleChange}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 500,
            }}
            placeholder="Ask a question about the course..."
            onBlur={() => setIsFocused(false)}
            onFocus={() => setIsFocused(true)}
            InputProps={{
              style: {
                transition: 'all 0.2s',
                ...(isFocused && {
                  boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.5)',
                }),
              },
            }}
          />
          <StyledIconButton
            type="submit"
            color="primary"
            disabled={!value || status !== 'ready'}
            data-test-id="search_sections_bet_send_icon"
            size="large"
          >
            <SendIcon />
          </StyledIconButton>
        </StyledPaper>
      </form>
      <Dialog
        open={isDeleteDialogOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Clear Chat History?</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to clear the chat history? This action cannot
            be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="primary"
            variant="contained"
          >
            Clear
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
